export const itemsShowOnCard = [
  {
    label: "Shared Class",
    value: "sharedClass",
  },
  {
    label: "Target IRR",
    value: "targetIrr",
  },
  {
    label: "Target Yield",
    value: "targetYield",
  },
  {
    label: "Strategy AUM",
    value: "strategyAUM",
  },
  {
    label: "Excepted Term",
    value: "expectedTerm",
  },
  {
    label: "Committed Capital",
    value: "committedCapital",
  },
  {
    label: "AUM",
    value: "aum",
  },
  {
    label: "Target Size",
    value: "targetFundSize",
  },
  {
    label: "Minimum Investment",
    value: "minimalInvestment",
  },
  {
    label: "Maturity",
    value: "maturity",
  },
  {
    label: "YTD Return",
    value: "ytdPerformance",
  },
  {
    label: "Last Month Return",
    value: "lastMonthPerformance",
  },
  {
    label: "Return Since Inception",
    value: "returnSinceInception",
  },
  {
    label: "Inception Date",
    value: "inceptionDate",
  },
  {
    label: "IRR",
    value: "irr",
  },
  {
    label: "Cash Yield",
    value: "cashYield",
  },
  {
    label: "Raised",
    value: "raised",
  },
  {
    label: "Size",
    value: "size",
  },
  {
    label: "Target Dividend",
    value: "targetDividend",
  },
  {
    label: "Investment Vehicle",
    value: "investmentVehicle",
  },
  {
    label: "Management Fee",
    value: "managementFee",
  },
  {
    label: "Performance Fee",
    value: "performanceFee",
  },
];
